import config from 'constants/config'
import getPaymentMethods from './getPaymentMethods'
import { SECURE_PAYMENT_TYPE } from 'constants/payment'

export const isSecurePaymentEnabled = (currencyCode: string): boolean => {
  return !!(currencyCode && config.SECURE_PAYMENT_ENABLED && getPaymentMethods(currencyCode).includes(SECURE_PAYMENT_TYPE))
}
